var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
// this file was temporarily copied
import { feature } from '@square/ember-features/macros';
import Service, { inject as service } from '@ember/service';
import { guidFor } from '@ember/object/internals';
import { Promise } from 'rsvp';
import * as Sentry from '@sentry/ember';
import { WEEBLY_HOST, WEEBLY_DOT_COM_MERCHANT_CHECK_URL, SQUAREUP_DOT_COM_MERCHANT_CHECK_URL, createMerchantBridgeInfoUrl } from '@square/dashboard-items-data/utils/sites/weebly';
import { ajax } from '@square/dashboard-utilities/utils/xhr';
import environment from '@square/environment-utils/environment';
import Logger from '@square/dashboard-utilities/utils/logger';
const TIMEOUT_ERROR_MESSAGE = 'message to weebly has timed out';
const TIMEOUT_ERROR = new Error(TIMEOUT_ERROR_MESSAGE);
let WeeblyApiBridge = (_dec = feature('ecom/show_buy_button'), _dec2 = feature('catalog/optimize_weebly_cors'), _class = class WeeblyApiBridge extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "userInfo", _descriptor, this);
    // a flag to indicate that the frame is ready for communication
    _defineProperty(this, "_initialized", false);
    // a map of guid --> promise reject/resolves so that we can turn postMessage protocol promise based.
    _defineProperty(this, "_promiseCallbacks", null);
    // a list of resolves that are awaiting the weebly side to be ready to receive messages
    _defineProperty(this, "_promisesAwaitingInitialization", null);
    _defineProperty(this, "_DEBUG_MODE", false);
    _defineProperty(this, "_squareSyncJwt", null);
    // Caches
    _defineProperty(this, "_weeblyUserInfoCache", null);
    _initializerDefineProperty(this, "canEcomShowBuyButton", _descriptor2, this);
    _initializerDefineProperty(this, "canUseSameDomainForWeebly", _descriptor3, this);
    this._promiseCallbacks = this._promiseCallbacks || {};
    this._promisesAwaitingInitialization = [];
    this._DEBUG_MODE = !environment().isProduction;
  }

  /**
   * Due to https://jira.weebly.net/browse/GM-2878?filter=12875, we cannot use the square-sync auth endpoints, however
   * we can rely on square-sync to tell us which squareup endpoint to initialize oauth on
   *
   * The url will be the value of the response's `oauth_url` key
   *
   * @param {Boolean?} createUser
   * @param {string} locationID
   * @returns {Promise}
   */
  getConnectOauthEndpoint(createUser = false, locationID = null) {
    let endpoint = `${WEEBLY_HOST}/app/square-sync/api/auth/square/silent?include_token`;
    if (createUser) {
      endpoint += '&create_user';
    }
    if (locationID) {
      endpoint += `&location_id=${locationID}`;
    }
    return this._squareSyncAjax(endpoint, 'GET');
  }

  /**
   * @returns {Boolean}
   */
  _canMakeRequestToWeebly() {
    /**
     * For staging we will depend on the feature-flag.
     * We need to be on weebly VPN to make this work on staging.
     * This works fine on production.
     */
    return !environment().isProduction && !this.canEcomShowBuyButton;
  }

  /**
   * @returns {Promise}
   */
  isWeeblyUser() {
    const {
      merchantToken: token
    } = this.userInfo;
    const options = {
      type: 'GET',
      dataType: 'json',
      timeout: 10000
    };

    // Note: Before removing this feature flag, some ECOM teammates are setting this to false as a workaround to access their local dev environments
    // Please consider that and reach out and notify them if removed
    const url = this.canUseSameDomainForWeebly ? SQUAREUP_DOT_COM_MERCHANT_CHECK_URL : `${WEEBLY_DOT_COM_MERCHANT_CHECK_URL}${token}`;

    // We don't use _squareSyncAjax() because that includes headers
    // (Authorization or Content-Type) that add an OPTIONS call to
    // this request.
    return ajax(url, options);
  }

  /**
   * @returns {Promise}
   */
  async cachedWeeblyUserInfo() {
    if (this._weeblyUserInfoCache) {
      return this._weeblyUserInfoCache;
    }
    try {
      this._weeblyUserInfoCache = await this.isWeeblyUser();
    } catch {
      this._weeblyUserInfoCache = null;
    }
    return this._weeblyUserInfoCache;
  }

  /**
   * @returns {Promise}
   */
  hasCrossedWeeblyBridge() {
    const {
      merchantToken: token
    } = this.userInfo;
    if (this._canMakeRequestToWeebly()) {
      return Promise.reject(new Error('Skip hasCrossedWeeblyBridge call for staging'));
    }

    // We don't use _squareSyncAjax() because that includes headers
    // (Authorization or Content-Type) that add an OPTIONS call to
    // this request.
    return ajax(createMerchantBridgeInfoUrl(token), {
      type: 'GET',
      dataType: 'json'
    });
  }

  /**
   * @returns {Promise}
   */
  isUserCreated() {
    return this._sendMessage({
      id: 'is_user_created'
    });
  }

  /**
   * @param {string} locationID
   * @returns {Promise}
   */
  createWeeblyUser(locationID = null) {
    return new Promise((resolve, reject) => {
      this.getConnectOauthEndpoint(true, locationID).then(response => {
        this._initialized = false;
        const iframe = this._getIframe();
        iframe.src = response.oauth_url;
        iframe.onload = () => {
          this.isUserCreated().then(result => {
            resolve(result);
          }).catch(error => {
            const data = error && error.data || {};
            Sentry.addBreadcrumb({
              message: 'Failed to check if user was created',
              data,
              level: 'info'
            });

            // The error modal will log 500s to sentry, everything else is handled.
            reject(data);
          });
        };

        // creating weebly users can take quite some time in some scenarios
        this._setMessageTimeout(reject, 30, 'create-weebly-user');
      }).catch(() => {
        Sentry.addBreadcrumb({
          message: 'Failed to get connect oauth endpoint',
          level: 'info'
        });
        reject(new Error('Failed to get connect oauth endpoint'));
      });
    });
  }

  /**
   * @param {String} endpoint
   * @param {String} type
   * @param {Object?} data
   * @returns {Promise}
   */
  _squareSyncAjax(endpoint, type, data = {}) {
    let payload = Object.assign({}, data, {
      square_merchant_id: this.userInfo.merchantToken
    });
    if (type !== 'GET') {
      payload = JSON.stringify(payload);
    }
    return ajax(endpoint, {
      type,
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      data: payload,
      headers: {
        Authorization: `Bearer ${this._squareSyncJwt}`
      }
    });
  }

  // private methods

  _receiveMessage(event) {
    // Ignore non-Weebly messages
    if (!event || !event.origin || !event.origin.toLowerCase().includes('weebly')) {
      return;
    }
    this._log('received message from weebly', event.data);
    if (event.data.uuid) {
      // this is a request we initiated
      const callbacks = this._promiseCallbacks[event.data.uuid];
      if (event.data.success) {
        callbacks.resolve(event.data);
      } else {
        callbacks.reject(event.data);
      }
      return;
    }

    // this is a request weebly initiated
    if (event.data.id === 'initialized') {
      this._onInitialized(event.data);
      return;
    }
    Sentry.addBreadcrumb({
      message: 'Weebly API Bridge postMessage response',
      data: {
        message: event.data,
        origin: event.origin
      },
      level: 'info'
    });
  }
  _onInitialized(payload) {
    this._initialized = true;
    this._squareSyncJwt = payload.data.jwt;
    this._log('weebly api bridge has been initialized');
    this._promisesAwaitingInitialization.forEach(resolve => {
      this._log('firing queued resolve');
      resolve();
    });
    this._promisesAwaitingInitialization = [];
  }

  /**
   * @param {Object} message
   * @returns {Promise}
   */
  _sendMessage(message) {
    return new Promise((resolve, reject) => {
      this.awaitFrameInitialization('_sendMessage').then(() => {
        message.uuid = guidFor(message);
        const frame = this._getIframe().contentWindow;
        this._log('sending message to weebly', message);
        frame.postMessage(message, WEEBLY_HOST);
        this._promiseCallbacks[message.uuid] = {
          resolve,
          reject
        };
        this._setMessageTimeout(reject, undefined, `send-message - ${message}`);
      }).catch(reject);
    });
  }

  /**
   * we'll assume something went wrong with the iframe communication if things take too long
   * this will reject the promise and allow us to show error messages
   * @param {Function} reject
   * @param {int?} seconds
   * @param {string?} context
   */
  _setMessageTimeout(reject, seconds, context) {
    const DEFAULT = environment().isProduction ? 30 : 50;
    const TIMEOUT_SECONDS = seconds || DEFAULT;
    const TIMEOUT_CONTEXT = context || 'unknown';
    const message = `${TIMEOUT_ERROR_MESSAGE}: ${TIMEOUT_CONTEXT}`;
    setTimeout(() => {
      Sentry.addBreadcrumb({
        message,
        level: 'info'
      });
      TIMEOUT_ERROR.message = message;
      reject(TIMEOUT_ERROR);
    }, TIMEOUT_SECONDS * 1000);
  }
  _getIframe() {
    return document.getElementById('weebly-api-bridge');
  }

  /**
   * @param {String} errorLabel
   * @returns {Promise}
   */
  awaitFrameInitialization(errorLabel = 'unknown') {
    return new Promise((resolve, reject) => {
      if (this._initialized) {
        resolve();
        return;
      }
      this._log('queuing message until frame is initialized');
      this._promisesAwaitingInitialization.push(resolve);
      this._setMessageTimeout(reject, undefined, `iframe-initialization (${errorLabel})`);
    });
  }
  _log(...args) {
    if (!this._DEBUG_MODE) {
      return;
    }
    Logger.debug(...args);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "canEcomShowBuyButton", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "canUseSameDomainForWeebly", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { WeeblyApiBridge as default };